import { Role } from '@gm-commercial/profile-model';

import {
  FLEETIO_ACCOUNT_LINKING_FLAG,
  FUEL_CARD_AND_EXPENSES_FLAG,
  LEGAL_PAGE_FLAG,
} from '~/common/models/featureFlags.model';
import {
  ACCOUNT_LEGAL_VIEW_PATH,
  ACCOUNT_ORG_INTEGRATIONS_PARTNER_PATH,
  ACCOUNT_ORG_INTEGRATIONS_PATH,
} from '~/common/models/pages/accountPages.model';
import { RouteName } from '~/common/models/route.model';
import { lazyWithReload } from '~/common/utils/lazyWithReload';

const LegalView = lazyWithReload(
  () => import('~/routes/account/organization/legal/LegalView')
);
const IntegrationsView = lazyWithReload(
  () => import('~/routes/account/organization/integrations/IntegrationsView')
);
const PartnerManageView = lazyWithReload(
  () => import('~/routes/account/organization/integrations/PartnerManageView')
);

export const ACCOUNT_ROUTES = {
  [RouteName.LEGAL]: {
    name: RouteName.LEGAL,
    path: ACCOUNT_LEGAL_VIEW_PATH,
    authorizedPerms: [],
    element: LegalView,
    requiredFeatureFlags: [LEGAL_PAGE_FLAG],
  },
  [RouteName.ACCOUNT_ORG_INTEGRATIONS]: {
    name: RouteName.ACCOUNT_ORG_INTEGRATIONS,
    path: ACCOUNT_ORG_INTEGRATIONS_PATH,
    authorizedPerms: [],
    authorizedRoles: [Role.ORG_MANAGER],
    element: IntegrationsView,
    // Visible if either partner's flag is on (mirrors the Shop Integrations gate).
    anyFeatureFlags: [
      FLEETIO_ACCOUNT_LINKING_FLAG,
      FUEL_CARD_AND_EXPENSES_FLAG,
    ],
  },
  [RouteName.ACCOUNT_ORG_INTEGRATIONS_PARTNER]: {
    name: RouteName.ACCOUNT_ORG_INTEGRATIONS_PARTNER,
    path: ACCOUNT_ORG_INTEGRATIONS_PARTNER_PATH,
    authorizedPerms: [],
    authorizedRoles: [Role.ORG_MANAGER],
    element: PartnerManageView,
    anyFeatureFlags: [
      FLEETIO_ACCOUNT_LINKING_FLAG,
      FUEL_CARD_AND_EXPENSES_FLAG,
    ],
  },
};
